import { StyleSheet } from 'react-native';

export const createStyles = () => {
  return StyleSheet.create({
    container: {
      flex: 1,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 16,
      borderBottomWidth: 1,
    },
    cancelText: {
      fontSize: 16,
      fontWeight: '600',
    },
    title: {
      fontSize: 18,
      fontWeight: '700',
    },
    createText: {
      fontSize: 16,
      fontWeight: '600',
    },
    content: {
      flex: 1,
    },
    scrollContent: {
      padding: 16,
    },
    section: {
      marginBottom: 24,
    },
    sectionTitle: {
      fontSize: 16,
      fontWeight: '600',
      marginBottom: 8,
    },
    textInput: {
      borderWidth: 1,
      borderRadius: 8,
      padding: 12,
      fontSize: 16,
      lineHeight: 22,
      minHeight: 150,
    },
    charCountContainer: {
      alignItems: 'flex-end',
      marginTop: 4,
    },
    charCount: {
      fontSize: 14,
    },
    imageContainer: {
      position: 'relative',
      width: '100%',
      height: 250,
    },
    imagePreview: {
      width: '100%',
      height: '100%',
      borderRadius: 8,
    },
    removeImageButton: {
      position: 'absolute',
      top: 8,
      right: 8,
      width: 32,
      height: 32,
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'center',
    },
    uploadButton: {
      height: 150,
      borderWidth: 2,
      borderStyle: 'dashed',
      borderRadius: 8,
      alignItems: 'center',
      justifyContent: 'center',
    },
    uploadText: {
      marginTop: 8,
      fontSize: 16,
    },
    pickerContainer: {
      borderWidth: 1,
      borderRadius: 8,
      overflow: 'hidden',
    },
    buttonContainer: {
      marginTop: 8,
    },
  });
};
